import { homeSelectors } from '..';

export const getHomePage = homeSelectors.selectById;
